import gql from 'graphql-tag';

export const GET_ADDITIONAL_ACCOUNT_OPTIONS = gql`
  query AdditionalAccountOptions {
    additionalAccount {
      result: getUserRelationsList {
        success
        error
        list {
          value: accountId
          label: accountName
        }
      }
    }
  }
`;
